"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.createAuthRouteHandlersFactory = void 0;
var createAuthRouteHandlersFactory_1 = require("./createAuthRouteHandlersFactory");
Object.defineProperty(exports, "createAuthRouteHandlersFactory", { enumerable: true, get: function () { return createAuthRouteHandlersFactory_1.createAuthRouteHandlersFactory; } });
